// shared-event.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SharedEventService {
  private closeSheetSubject = new Subject<any>();

  closeSheet$ = this.closeSheetSubject.asObservable();

  emitCloseSheet(data?: any) {
    this.closeSheetSubject.next(data);
  }
}
